module.exports = __webpack_public_path__ + "static/media/logoWhite.09ef583c.svg";